<template>
  <q-card @click="onThumbClick" class="col-6 social-thumb-wrapper" style="border-radius: 8px; min-width: 225px" :style="{'background-color': backgroundColor}">
    <q-card-section class="q-px-md q-py-sm">
      <div class="row items-center">
        <img :src="icon"/>
          <div class="text-subtitle1 q-ml-sm">{{ text }}</div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script setup lang="ts">
import type {Action} from "@/types/link.type";
import {CommandsEnum, SocialMedias} from "@/types/link.type";
import {computed, defineEmits} from "vue";
import {commandToTitle} from "@/utils/SocialMedia.mapper";
import {socialMediaToSvg} from "@/utils/SocialToIcon.mapper";

export interface SocialThumbProps {
  action: Action
  disabled?: boolean
}

const props = defineProps<SocialThumbProps>()
const emit = defineEmits(['thumbClick'])
const text = computed<string>(() => commandToTitle(props.action.command as CommandsEnum))
const backgroundColor = computed<string>(() => {
  return props.disabled ? "#ffffff1f" : socialMediaToBackgroundMap[props.action.type!]
})
const icon = computed<string>(() => socialMediaToSvg(props.action.type!))

function onThumbClick() {
  const target = buildCommandUrl()
  window.open(target)
  emit('thumbClick')
}


const socialMediaToBackgroundMap = {
  [SocialMedias.YOUTUBE]: "#e62117",
  [SocialMedias.TWITTER]: "#1b95e0",
  [SocialMedias.INSTAGRAM]: "#3897f0",
  [SocialMedias.FACEBOOK]: "#4267b2",
  [SocialMedias.TIKTOK]: "#000000",
  [SocialMedias.ONLYFANS]: '#3eb9f1',
  [SocialMedias.SOUNDCLOUD]: "#f70",
  [SocialMedias.SPOTIFY]: "#1db954",
  [SocialMedias.TWITCH]: "#9147ff",
  [SocialMedias.DISCORD]: "#7289da",
  [SocialMedias.TELEGRAM]: "#08c",
  [SocialMedias.BEHANCE]: "#0057ff",
  [SocialMedias.LINKEDIN]: "#0a66c2",
  [SocialMedias.PINTEREST]: "#e60022",
  [SocialMedias.OTHER]: "#00e676",
}


function buildCommandUrl() {
  const cmd = props.action.command
  const url = props.action.value?.concat() || ""

  if (cmd === CommandsEnum.YOUTUBE_SUBSCRIBE) {
    return url + "?sub_confirmation=1"
  }

  return url;
}
</script>

<style scoped>
.social-thumb-wrapper {
  cursor: pointer;
}
</style>